<template>
  <!--  :show-create-button="$auth.hasRight('roles__edit_information')"-->
  <template-list
    :model="$promocodeCondition"
    :auto-load-list="false"
    :show-create-button="$auth.hasRight('promocode_condition__edit')"
  >
    <template v-slot:actions>
      <v-menu
          :close-on-content-click="false"
          :nudge-right="40"
          max-width="290px"
          min-width="290px"
          offset-y
          transition="scale-transition"
      >
        <template v-slot:activator="{ on }">
          <v-btn depressed class="rounded-lg mr-3" color="primary" v-on="on">
            <v-icon>mdi-filter</v-icon>
          </v-btn>
        </template>
        <v-list class="pt-4 px-3">
          <v-row align="center" class="ma-0" justify="space-between">
            <div class="subtitle-2">Фильтрация</div>
            <v-btn text x-small @click="clearFilter()">Сбросить фильтр</v-btn>
          </v-row>

          <v-text-field
              v-model="$promocodeCondition.filters.search"
              label="Наименование"
              v-bind="inputProps"
          />
          <div class="mt-3 text--secondary">Срок действия</div>
          <v-row class="ma-0">
            <v-col class="pa-0" cols="6">
              <date-picker
                  v-model="$promocodeCondition.filters.start_date"
                  class="mr-1 body-2"
                  label="С"
                  v-bind="{ ...inputProps, class: undefined }"
              />
            </v-col>
            <v-col class="pa-0" cols="6">
              <date-picker
                  v-model="$promocodeCondition.filters.end_date"
                  class="ml-1 body-2"
                  label="По"
                  v-bind="{ ...inputProps, class: undefined }"
              />
            </v-col>
          </v-row>
          <v-checkbox
              class="ma-0 mt-3"
              dense
              label="Только действующие"
              :value="$promocodeCondition.filters.works"
              @change="
                $promocodeCondition.filters.works = $event || undefined
              "
              hide-details
          />
          <v-row
              align="center"
              class="mx-0 mb-0 mt-3 pb-2 pt-2"
              style="position: sticky; bottom: 0; background: white"
          >
            <v-btn color="primary" small @click="loadList()">Применить</v-btn>
          </v-row>
        </v-list>
      </v-menu>
    </template>
    <template v-slot:subactions>
      <v-row no-gutters style="gap: 10px">
        <v-btn
          depressed
          :color="
            selectedType === $promocodeCondition.typeEnum.DEFAULT
              ? 'primary'
              : ''
          "
          @click="selectedType = $promocodeCondition.typeEnum.DEFAULT"
        >
          <div class="text-none">Обычные</div>
        </v-btn>
        <v-btn
          depressed
          :color="
            selectedType === $promocodeCondition.typeEnum.TEXT ? 'primary' : ''
          "
          @click="selectedType = $promocodeCondition.typeEnum.TEXT"
        >
          <div class="text-none">Текстовые</div>
        </v-btn>
      </v-row>
    </template>
    <template v-slot="{ object, to, index }">
      <v-col class="pa-0 body-2 pointer">
        <router-link :to="to" style="width: 100%; height: 100%">
          <v-row no-gutters align="start link">
            <v-col class="">
              <div>
                Наименование: <b>{{ object.name }}</b>
              </div>
              <div style="margin-top: 2px">
                Статус:
                <span
                  :style="{
                    color: $promocodeCondition.statusColor[object.status],
                  }"
                >
                  {{ $promocodeCondition.statusName[object.status] }}</span
                >
              </div>
              <div style="margin-top: 2px">
                Действует:
                <b
                  :style="{
                    color: object.works ? 'green' : 'gray',
                  }"
                >
                  {{object.works ? 'Да' : 'Нет'}}
                </b
                >
              </div>
              <div style="margin-top: 2px">
                {{ getConditionPerionAsText(object) }}
              </div>
            </v-col>
          </v-row>
        </router-link>
      </v-col>
    </template>
  </template-list>
</template>

<script>
import { parseDate } from "@/services/parseDate";

export default {
  name: "PromocodeConditionsList",
  components: {},
  data: () => ({
    selectedType: 1,
    inputProps: {
      class: "project-search-input pa-0 rounded-lg mt-3 ",
      dense: true,
      hideDetails: true,
      outlined: true,
      rounded: true,
      style: "transition: 0.3s",
      clearable: true,
    },
  }),
  methods: {
    getConditionPerionAsText(item) {
      if (!item.start_date && !item.end_date)
        return "Период действия не ограничен";
      let res = "";
      if (item.start_date) res = `с ${parseDate(item.start_date)} `;
      if (item.end_date) res += `по ${parseDate(item.end_date)}`;
      return res;
    },
    loadList() {
      this.$promocodeCondition.filters.type = this.selectedType;
      this.$promocodeCondition.loadList({ type: this.selectedType });
    },
    clearFilter() {
      this.$promocodeCondition.filters = {}
      this.loadList()
    }
  },
  created() {
    const selectedType = this.$route.query.type;
    if (selectedType) this.selectedType = Number(selectedType);
    this.loadList();
  },
  watch: {
    selectedType() {
      if (Number(this.$route.query.type) !== this.selectedType)
        this.$router.replace({
          name: this.$route.name,
          query: { type: this.selectedType },
        });
      this.loadList();
    },
  },
};
</script>
